<template>
  <div>
    <div class="menu-back-wrap">
      <div class="menu-back"></div>
    </div>
    <topnav></topnav>
    <div class="videoPage" v-if="item">
<div class="joystick-wrap">
<div class="joystick">
    <img src="../assets/joystick-white.svg" alt="Joystick white"  />
  
</div> 
<div>
  <h1 class="txt60 blue-txt">{{ item.title }}</h1>
  <h3 class="videoPageSub" v-if="item.subHeader">{{ item.subHeader }}</h3>
  <div
    class="txt20 light videoPageBody"
    v-if="item.body"
    v-html="item.body"
  >
  </div>
</div>
</div>
      <div class="w1170 videoPageVideo" v-if="item.videoLink">
        <video playsinline :src="item.videoLink" controls></video>
      </div>

      <div class="txt20 light videoPageContactUs" v-if="item.contactUs">
        <div v-html="item.contactUs"></div>
      </div>
    </div>

    <div class="faq-page-wrap center" v-else>
      <h3 class="txt60 red">Video Page</h3>
      <p class="txt20 light">Video page not found.</p>
    </div>

    <botfooter></botfooter>
  </div>
</template>

<script>
import Botfooter from "@/components/Botfooter.vue";
import Topnav from "@/components/Topnav.vue";
export default {
  components: {
    Topnav,
    Botfooter,
  },
  name: "VideoPage",
  computed: {
    item() {
      const { slug } = this.$route.params;
      return this.$local.videoPages.find((n) => n.slug == slug);
    },
  },
};
</script>

<style>
.joystick-wrap {
  display: flex;
  align-items: start;
  gap: 20px;
  justify-content: center;
  margin-bottom: 20px;
  text-align: start !important;
  gap: 2rem;
}
.joystick-wrap .txt60 {
  text-align: start !important;
  color: #27568b;
}
.joystick{
  width: 200px;
  flex-shrink: 0;
  height: 200px;
  background: #ed4b4b;
  padding: 10px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.joystick img{
  width: 160px;
}
.videoPage {
  background: #f9f9f9;
  border-radius: 30px;
  padding: 40px;
  max-width: 1170px;
  width: 98%;
  margin: 3rem auto;
  position: relative;
  z-index: 3;
}

.videoPage h1 {
  text-align: center !important;
  font-weight: 900;
  font-style: italic;
  line-height: 1.2;
  margin: 0;
  color: #ed4b4b;
}
.videoPageSub {
  margin-top: 40px;
  /* color: #27568b; */
  /* text-align: center; */
}

.videoPageVideo {
  margin: 30px 0;
  width: 100%;
}

.videoPageVideo video {
  width: 100%;
  border-radius: 15px;
}

.videoPageBody,
.videoPageContactUs {
  line-height: 1.6;
  text-align: left;
  margin: 0 auto;
}

.videoPageBody h2,
.videoPageContactUs h2 {
  font-weight: 900;
  font-style: italic;
  line-height: 1;
  margin: 0;
}
.videoPageContactUs {
  margin-top: 40px;
  text-align: center;
    max-width: 700px;

}

.videoPageContactUs a {
  color: #ed4b4b;
  font-weight: 600;
  text-decoration: none;
  font-size: 18px;
}

.videoPageContactUs a:hover {
  text-decoration: underline;
}

@media screen and (max-width: 768px) {

  .joystick-wrap {
  display: block;
}

.joystick{
  width: 150px;
  height: 150px;
  margin-bottom: 2rem;
}



  .videoPage h1 {
    font-size: 30px;
  }
  .videoPage {
    padding: 20px;
    margin-top: 2rem;
    line-height: 1.4;
  }

  .videoPageSub {
    font-size: 20px;
    margin-top: 1rem;
  }
  .videoPageVideo video {
    border-radius: 10px;
  }
}
</style>
